export const DEFAULT_RETRY_CONFIG = {
  enabled: true,
  maxAttempts: 5,
  persistent: false, // stop after 5 attempts
  initialDelayMs: 1000,
  maxDelayMs: 30000,
  backoffMultiplier: 2
}
